import _ from 'lodash'
import React, { Component } from 'react'
import styled from 'styled-components'
import * as API from '../api'

const StyledPage = styled.div`
  position: absolute;
  top: 50%;
  width: 100%;
`

const Form = styled.form`
  font-size: 40px;
  width: 80%;
  position: relative;
  margin: auto;
  text-align: center;
  line-height: 2;
`

const Input = styled.input`
  width: 25%;
  border: 1px solid black;
  font-size: 40px;
`

const Button = styled.button`
  font-size: 40px;
`

class ProvisionPage extends Component {
  state = {
    provision_code: ''
  }

  render() {
    return (
      <StyledPage>
        <Form onSubmit={this._doProvision}>
          <b>Setup</b><br />
          <label>Enter Provision Code<br />
            <Input type="text" name="provision_code" value={this.state.provision_code} onChange={this._handleChange} />
          </label> <Button onClick={this._doProvision}>Submit</Button>
        </Form>
      </StyledPage>
    )
  }

  _handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  _doProvision = (e) => {
    e.preventDefault()
    const { provision_code } = this.state
    if (_.isEmpty(provision_code)) {
      alert('Please enter a Provision Code')
      return false
    }
    API.authorise(provision_code).then(json => {
      const { active_id_secret_pair, hardware } = json.internal_app
      API.setAuthToken(active_id_secret_pair.app_id, active_id_secret_pair.app_secret)
      localStorage.setItem('storeCode', hardware.store.code)
      this.props.onNext()
    }).catch((err) => {
      alert(_.get(err, 'errors.[0].message'))
      this.errorCount++
    })
    return false
  }
}

ProvisionPage.defaultProps = {

}

export default ProvisionPage



// WEBPACK FOOTER //
// ./src/components/ProvisionPage.js